import createIcon from '@/lib/create-icon'

const MagnifyingGlassIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'>
    <path
      d='M17.5 17.5L14.3125 14.3125M9.43792 2.5C5.61234 2.5 2.5 5.5274 2.5 9.24959C2.5 12.9718 5.61234 16 9.43792 16C13.2627 16 16.375 12.9718 16.375 9.24959C16.375 5.5274 13.2627 2.5 9.43792 2.5Z'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
      fill='none'
    />
  </svg>,
  'MagnifyingGlassIcon'
)

export default MagnifyingGlassIcon
